import React from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import * as auth from '../../modules/Auth/_redux/authRedux';

const BannerWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 800px;
  color: #721c24;
  background-color: #f8d7da;
  padding: 8px 12px;
  text-align: center;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  border: 1px solid #721c24;
  border-radius: 8px 8px 0 0;
`;

export default function ImpersonateBanner() {
  const dispatch = useDispatch();
  const impersonateExpiresAt = useSelector(
    (state) => state.auth.impersonateExpiresAt,
  );
  const impersonateAdminEmail = useSelector(
    (state) => state.auth.impersonateAdminEmail,
  );

  if (!impersonateExpiresAt) {
    return null;
  }

  const handleEndSession = () => {
    dispatch(auth.actions.logout());
  };

  const formattedExpiration = new Date(impersonateExpiresAt).toLocaleString(
    'pt-BR',
  );

  return (
    <BannerWrapper>
      <span>
        Sessão sendo acessada pelo administrador:{' '}
        <strong>{impersonateAdminEmail}</strong>. Expira em:{' '}
        <strong>{formattedExpiration}</strong>
      </span>
      <Button
        variant="outlined"
        onClick={handleEndSession}
        sx={{
          marginLeft: '20px',
          borderColor: '#721c24',
          color: '#721c24',
          '&:hover': {
            borderColor: '#721c24',
            backgroundColor: 'rgba(114, 28, 36, 0.15)',
            color: '#5a161d',
          },
        }}
      >
        Encerrar Sessão
      </Button>
    </BannerWrapper>
  );
}
